if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        // se muestra SOLO la imagen pulsada (movil y ordenador); las demas se ocultan
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          if (element.getAttribute('data-media-id') !== mediaId) {
            element.classList.remove('active');
            element.style.display = 'none';
          }
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.style.display = 'block';

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = 0;
        container.scrollTop = 0;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
